<div class="row">

  <!-- <div class="col-4">

    <div class="row" style="display: flex; flex-direction: column" *ngIf="interceptorData">
      <div class="px-3" style="margin-top: 5px" *ngFor="let key of interceptorData; index as index">
        <div class="form-group header-fields">
          <a style="position: relative; left: -4px;" class="navbar-brand text-decoration-none">{{ key.label }}: {{
            key.value ? key.value : 'Non impostato' }}</a>
        </div>
      </div>
    </div>

  </div> -->

  <div class="col-4"></div>

  <!-- <div class="col-4 it-header-slim-right-zone">
      <div class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" style="align-items: center; display: flex; color: white;" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          <span>Azioni</span>
          <svg class="icon d-none d-lg-block"></svg>
        </a>
        <div class="dropdown-menu">
          <div class="row">
            <div class="col-12">
              <div class="link-list-wrapper">
                <ul class="link-list">
                  <li><a class="dropdown-item list-item" href="/dashboard"><span>Dashboard <span class="visually-hidden">selezionata</span></span></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

</div>